<template>
  <div class="inline-block">
    <div class="image-container">
      <slot></slot>
      <div v-if="show" class="after">
        <div class="flex content-center justify-center flex-col h-full">
          <div class="text-center">{{ text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageOverlay",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.image-container .after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  color: #FFF;
  background: rgba(0, 0, 0, .6);
}
.image-container:hover .after {
  display: block;
  background: rgba(0, 0, 0, .6);
}
</style>
